import React, { useState } from 'react';
import { Box, alpha, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';
import { ScaleAnimation } from '../../animations/MotionWrapper';
import { ROUTES } from '../../../constants/routes';
import { useBranding } from '../../../context/BrandingContext';

/**
 * NavLogo - Logo component for the navigation bar
 * Tries /branding/logo.png first (instance-specific), falls back to default.
 */
const NavLogo = () => {
  const theme = useTheme();
  const { instance_name } = useBranding();
  const [logoSrc, setLogoSrc] = useState('/branding/logo.png');

  return (
    <Box
      component={Link}
      to={ROUTES.HOME}
      sx={{
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none',
        flexShrink: 0,
        mr: { xs: 0, sm: 1, md: 2 },
        '&:hover': {
          textDecoration: 'none'
        },
      }}
    >
      <ScaleAnimation>
        <Box
          sx={{
            backgroundColor: 'white',
            padding: { xs: 0.75, md: 1 },
            borderRadius: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: `0 2px 8px ${alpha(theme.palette.common.black, 0.15)}`,
            transition: 'all 0.3s ease',
            '&:hover': {
              boxShadow: `0 4px 12px ${alpha(theme.palette.common.black, 0.2)}`,
            }
          }}
        >
          <Box
            component="img"
            src={logoSrc}
            alt={`${instance_name} Logo`}
            onError={() => setLogoSrc('/kon_logo_small.png')}
            sx={{
              height: { xs: 28, sm: 30, md: 36 },
              width: 'auto',
              borderRadius: '4px',
            }}
          />
        </Box>
      </ScaleAnimation>
    </Box>
  );
};

export default NavLogo;
